/* Email offer: exact allowlisted code, one fixed discount per cart. */
(function () {
  'use strict';
  var offer = {"code": "K-SUMMER-9435803F", "amount": 9000, "endsAt": "2026-09-07T14:59:00Z", "link": "https://kokochidry.shop/products/kokochidry?ec_offer=K-SUMMER-9435803F"};
  var key = 'ec-special-offer-v1';
  var selected = false;
  try {
    selected = new URLSearchParams(location.search).get('ec_offer') === offer.code || sessionStorage.getItem(key) === offer.code;
    if (selected) sessionStorage.setItem(key, offer.code);
  } catch (_) {}
  function current() { return selected && Date.now() < Date.parse(offer.endsAt) ? offer : null; }
  function clear() { selected = false; try { sessionStorage.removeItem(key); } catch (_) {} }
  window.EC_SPECIAL_OFFER = {current:current, clear:clear};
  window.EC_OFFER_AMOUNT = function () { var active=current(); return active ? active.amount : 2000; };
  function syncCartNotice() {
    var active=current(); if(!active)return;
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function(root){
      var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),node;
      while((node=walker.nextNode())) {
        if(node.nodeValue.indexOf('メール登録で2,000円OFF')>=0) node.nodeValue=node.nodeValue.replace('メール登録で2,000円OFF','本日限定・注文合計'+active.amount.toLocaleString('ja-JP')+'円OFF');
      }
    });
  }
  if (typeof document!=='undefined') document.addEventListener('DOMContentLoaded',function(){
    syncCartNotice();
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(function(root){new MutationObserver(syncCartNotice).observe(root,{childList:true,subtree:true});});
  },{once:true});
})();
